import { BASE_ENDPOINT } from "../../../endpoint";

export const emailCustomerAccountStatementService = async (
	token: string,
	payload: Record<string, any>,
	filters: { [key: string]: string }
) => {
	const queryParams = new URLSearchParams(filters).toString();
	try {
		const response = await fetch(
			`${BASE_ENDPOINT}/user/customerservice/accountstatement/${payload?.accountNumber}/email?${queryParams}`,
			{
				method: "POST",
				headers: {
					Authorization: `Bearer ${token}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(payload),
			}
		);
		const res = await response.json();
		if (!response.ok) {
			console.error("Error:", res);
			throw new Error(res.message);
		}
		return res;
	} catch (error) {
		console.error("API fetch error:", error);
		throw error;
	}
};
